function reFormatPostcodeValue(value) {
  const formattedValue = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  const spacedPostcode = formattedValue.replace(
    /^([A-Za-z]{1,2}\d{1,2})(\d{1})([A-Za-z]{2})$/,
    "$1 $2$3"
  );
  return spacedPostcode;
}

function resetFormFieldValidation(validationWrapperEL, validationMessageEl) {
  validationWrapperEL.classList.remove("c-validation-message--is-valid");
  validationWrapperEL.classList.remove("c-validation-message--is-invalid");
  validationMessageEl.innerHTML = "";
}

function validateFormField(wrapperEl, messageEl, valid, invalid, message) {
  resetFormFieldValidation(wrapperEl, messageEl);
  if (valid) {
    wrapperEl.classList.add("c-validation-message--is-valid");
  } else if (invalid) {
    wrapperEl.classList.add("c-validation-message--is-invalid");
    messageEl.innerHTML = message;
  }
}

function removeSelectOptions(selectEl) {
  selectEl.innerHTML = "";
}

function initPostcodeLookup(element) {
  const postcodeInput = element.querySelector(".js-water-field");
  const searchButton = element.querySelector(".js-water-search-button");
  const validationWrapperEl = element.querySelector(
    ".js-water-validation-wrapper"
  );
  const validationMessageEl = element.querySelector(
    ".js-water-validation-message"
  );
  const successAddress = element.querySelector(".js-water-success-address");
  const successResult = element.querySelector(".js-results");
  const searchGroup = element.querySelector(".js-search");
  const manualAddress = element.querySelector(".js-water-manual-address");
  const selectAddressLine = element.querySelector(".js-water-select-address");
  const backButton = element.querySelector(".js-back-button");

  const formItems = [];

  function resetPostcodeLookupValidation() {
    if (validationWrapperEl) {
      resetFormFieldValidation(validationWrapperEl, validationMessageEl);
    }
  }

  function resetPostcodeLookup() {
    resetPostcodeLookupValidation();
    if (postcodeInput) {
      postcodeInput.value = "";
    }

    if (selectAddressLine) {
      const placeholderOption = new Option("Please select", "");
      removeSelectOptions(selectAddressLine);
      selectAddressLine.add(placeholderOption, undefined);
    }
  }

  let selectedAddress = {};

  function onSelectAddressConfirm(event, data) {
    const selectedAddressValues = [
      event.target.value
    ];
    if (formItems) {
      formItems.map((item, index) => {
        const input = item.inputEl;
        input.value = selectedAddressValues[index];
        const newEvent = new Event("change");
        input.dispatchEvent(newEvent);
      });
    }

    selectedAddress = {
      Year: event.target.value
    };
  }

  function updateResultContent(heading, body) {
    const resultsContainer = element.querySelector('.js-water-meter-results');

    resultsContainer.innerHTML = '';

    const headingEl = document.createElement("h2");
    headingEl.className = 'c-postcode-results__heading u-color__title';
    headingEl.textContent = heading;

    const bodyEl = document.createElement("p");
    bodyEl.className = 'c-postcode-results__body u-color__summary';
    bodyEl.textContent = body;

    resultsContainer.append(headingEl);
    resultsContainer.append(bodyEl);
  }


  function onPostcodeLookupLoading() {
    if (searchButton) {
      searchButton.classList.add("is-loading");
      searchButton.innerHTML = 'Finding address<div class="c-spinner"><div>';

      var liveRegion = document.getElementById('notificationLiveRegion');
      if (liveRegion) {
        liveRegion.textContent = "Please wait, Finding address";
      }
    }
    resetPostcodeLookupValidation();
    if (successAddress) {
      successAddress.classList.add("is-closed");
      successAddress.classList.remove("is-open");
    }
  }

  function onPostcodeLookupFormSuccess(data) {
    searchButton.classList.remove("is-loading");
    searchButton.innerHTML = "Find address";
    validationWrapperEl.classList.add("c-validation-message--is-valid");
    successAddress.classList.remove("is-closed");
    var liveRegion = document.getElementById('notificationLiveRegion');
    if (liveRegion) {
      liveRegion.textContent = "Addresses found. Please select an address.";
    }
    selectAddressLine.focus();


    if (selectAddressLine) {
      removeSelectOptions(selectAddressLine);

      selectAddressLine.addEventListener("change", (event) => {
        onSelectAddressConfirm(event, data);

        try {
          fetch('/ytlapi/propertylookup/message', {
            method: "POST",
            body: JSON.stringify(selectedAddress),
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              updateResultContent(data.title, data.body);
              searchGroup.classList.remove("js-active");
              successResult.classList.add("js-active");
            });
        } catch (error) {
          console.error("Error:", error);
        }
      });

      const placeholderOption = new Option("Please select", "");
      selectAddressLine.add(placeholderOption, undefined);
      data.propertyDetails.forEach((address) => {
        const newOption = new Option(
          address.houseNameAndStreet,
          address.year
        );
        selectAddressLine.add(newOption, undefined);
      });
    }
  }

  function onPostcodeLookupFormError() {
    searchButton.classList.remove("is-loading");
    searchButton.innerHTML = "Find address";
    validationWrapperEl.classList.add("c-validation-message--is-invalid");
    validationMessageEl.innerHTML =
          'Sorry! We don\'t recognise your postcode.<br>You either live outside our region or your postcode hasn\'t been registered with us yet.<br> Visit <a href="https://www.water.org.uk/" target="_blank" rel="noreferrer">Water UK\'s website</a> to check who supplies you.';
  }

  function handlePostcodeLookupFormSubmit(event) {
    event.preventDefault();

    const postcodeValue = event.target.postcode.value
      .toLowerCase()
      .split(" ")
      .join("+");
    onPostcodeLookupLoading();

    fetch(`/ytlapi/propertylookup/postcode?postcode=${postcodeValue}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.propertyDetails && data.propertyDetails.length) {
          onPostcodeLookupFormSuccess(data);
        } else {
          onPostcodeLookupFormError();
        }
      })
      .catch((data) => {
        onPostcodeLookupFormError();
      });
  }

  function handleEnterManualAddress() {
    successAddress.classList.remove("is-open");
    successAddress.classList.add("is-closed");
    manualAddress.classList.add("is-open");
    resetPostcodeLookup();
  }

  if (postcodeInput && searchButton) {
    postcodeInput.addEventListener("input", () => {
      const value = postcodeInput.value.trim();
      const reformatedValue = reFormatPostcodeValue(value);
      searchButton.disabled = !reformatedValue;
      postcodeInput.value = reformatedValue;
    });
  }

  const manualButton = element.querySelector(".js-manual-postcode");
  if (manualButton) {
    manualButton.addEventListener("click", (event) => {
      event.preventDefault();
      handleEnterManualAddress();
    });
  }


  if (backButton) {
    backButton.addEventListener("click", () => {
      successResult.classList.remove("js-active");
      searchGroup.classList.add("js-active");
      manualAddress.classList.add("is-closed");
      manualAddress.classList.remove("is-open");
      successAddress.classList.add("is-closed");
      successAddress.classList.remove("is-open");

      resetPostcodeLookup();
    });
  }

  const formGroups = element.querySelectorAll(".js-water-form-group");
  if (formGroups.length) {
    formGroups.forEach((formGroup) => {
      const input = formGroup.querySelector(".c-form-field__input");
      if (input) {
        const inputName = input.name.split("-")[0];
        const formItem = formItems.filter((item) => item.name === inputName)[0];
        if (formItem) {
          formItem.inputEl = input;
          const fgValidationWrapperEl = formGroup.querySelector(
            ".js-validation-wrapper"
          );
          const fgValidationMessageEl = formGroup.querySelector(
            ".js-validation-message"
          );
          if (fgValidationWrapperEl && fgValidationMessageEl) {
            formItem.validationEl = fgValidationWrapperEl;
            formItem.validationMessageEl = fgValidationMessageEl;
            input.addEventListener("change", (event) => {
              const value = event.target.value.trim();
              if (value.length) {
                validateFormField(
                  fgValidationWrapperEl,
                  fgValidationMessageEl,
                  true,
                  false,
                  ""
                );
              } else {
                validateFormField(
                  fgValidationWrapperEl,
                  fgValidationMessageEl,
                  false,
                  true,
                  formItem.validationMessage
                );
              }
            });
            if (inputName === "confirmedPostcode") {
              input.addEventListener("input", (event) => {
                const value = event.target.value.trim();
                event.target.value = reFormatPostcodeValue(value);
              });
            }
          }
        }
      }
    });
  }

  const form = element.querySelector(".js-water-lookup-form");
  if (form) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      handlePostcodeLookupFormSubmit(event);
    });
  }
}

function init() {
  const elementsWithClass = document.querySelectorAll(".js-water-lookup");

  elementsWithClass.forEach((element) => {
    initPostcodeLookup(element);
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/water-meter-tool/water-meter-tool.js